<template>
    <div>
        <term></term>
    </div>
</template>
<script>
import term from '@termsH5/term.vue';
export default {
    name: "terms-h5",
    components: {
        term
    }
}
</script>
<style lang="scss" scoped>

</style>